import React from "react";
import CardsDesktop from "../../cards/CardsDesktop";

const Page = () => (
    <div className="cards">
        <CardsDesktop></CardsDesktop>
    </div>
);

export default Page;